import request from '@/utils/request'

export function pay (query) {
  return request({
    url: '/pay/pay',
    method: 'post',
    data: query
  })
}

export function paySorce (query) {
  return request({
    url: '/api/mySource',
    method: 'get',
    params: query
  })
}

export function ready (query) {
  return request({
    url: '/pay/ready',
    method: 'get',
    params: query
  })
}